// 登录页：飞书风格居中卡片 + 飞书登录按钮（扫码/免登同一 OAuth 流程）。

import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { Alert, Button } from "@bf/ui";

export function LoginPage() {
  const { login } = useAuth();
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async () => {
    setLoading(true);
    setError(null);
    try {
      await login(params.get("redirect") ?? "/");
    } catch {
      setError("无法打开飞书登录，请稍后重试");
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f5f6f7] p-4">
      <div className="w-full max-w-sm rounded-[10px] border border-gray-200 bg-white p-8 shadow-sm">
        <div className="text-center">
          <div className="mx-auto flex h-11 w-11 items-center justify-center rounded-[10px] bg-brand text-lg font-semibold text-white" aria-hidden>
            跃
          </div>
          <h1 className="mt-4 text-xl font-semibold text-gray-900">跃迁积分</h1>
          <p className="mt-1.5 text-sm text-gray-500">让每一份贡献都被看见</p>
        </div>
        <div className="mt-8">
          <Button variant="primary" className="h-11 w-full text-base" loading={loading} onClick={() => void handleLogin()}>
            使用飞书登录
          </Button>
          {error && (
            <Alert tone="danger" className="mt-3">
              {error}
            </Alert>
          )}
          <p className="mt-4 text-center text-xs text-gray-500">仅支持飞书账号登录（扫码或免登）</p>
        </div>
      </div>
    </div>
  );
}
